import { render, staticRenderFns } from "./Slat.vue?vue&type=template&id=028cbc0c"
import script from "./Slat.vue?vue&type=script&lang=js"
export * from "./Slat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports